import { render } from "./CheckTemplate.vue?vue&type=template&id=1b292c9d&scoped=true"
import script from "./CheckTemplate.vue?vue&type=script&lang=js"
export * from "./CheckTemplate.vue?vue&type=script&lang=js"

import "./CheckTemplate.vue?vue&type=style&index=0&id=1b292c9d&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b292c9d"]])

export default __exports__